
import {Link, NavLink} from "react-router-dom" 
import { useAppContext } from '../../Context/Store';

export const Footer = ({ onSendData }) => { 
    const { isError, isLoading, ContactData } = useAppContext();
    //const [inputValue, setInputValue] = useState(true);

    //console.log("Default Value", inputValue);
    //console.log("About Page Component", ContactData);
    const { properties } = ContactData;

    // Function to handle input change
    const handleChange = () => { 
        //setInputValue(true);
        onSendData(true);
        //console.log("Click Value", inputValue);
    };
    const today = new Date();
    return (
      <>
        <footer>
            <div id="footer">  
                <div className="footnav">
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="our-collection">Our collection</NavLink>
                    <NavLink to="customized">Customized</NavLink>
                    <NavLink to="about-us">About us</NavLink>
                    <NavLink to="contact">Contact</NavLink>
                    <a className="enq-b" onClick={handleChange}>Enquire now</a>
                    <NavLink to="our-collection">All products</NavLink> 
                    <NavLink to="faqs">Faqs</NavLink>
                    {/* <NavLink to="reviews.html">Reviews</NavLink> */}
                    {/* <NavLink to="why-choose-us">Why choose us</NavLink> */}
                    <a className="enq-b" onClick={handleChange}>Request a quote</a>
                 </div>
                <NavLink className="flogo ir" to="/" target="_blank" title={properties?.copyRightText || "Promovara"}>{properties?.copyRightText || "Promovara"}</NavLink>
                <div className="copyright">
                    <NavLink to="privacy-policy">Privacy policy</NavLink>
                    <NavLink to="terms-conditions">Terms &amp; conditions</NavLink>
                    <span>©{today.getFullYear()} {properties?.copyRightText || "Promovara"}</span>
                    <a className="call" href={`tel:+${properties?.phoneNo.replace(/ /g, '')}`} target='_blank'>+{properties?.phoneNo || ""}</a>
                    <a className="email" href={`mailto:${properties?.emailAddress}`}>{properties?.emailAddress || ""}</a>
                </div>
                <div className="fsocial"> 
                    <a className="facebook ir " href="https://www.facebook.com/people/Corporate-Giveaways/61567554885409/" target="_blank">Facebook</a>
                    <a className="instagram ir " href="https://www.instagram.com/corporategiveawayspk/" target="_blank">Instagram</a>
                    <a className="linkedin ir" href="#" target="_blank">Linkedin</a>
                    <a className="tiktok ir" href="#" target="_blank">Tiktok</a>
                    <a className="youtube ir" href="#" target="_blank">Youtube</a>
                </div>
            </div> 
        </footer>
      </>
    )
}
